import React, { useRef, useState } from 'react';
import SignaturePad from 'react-signature-canvas';
import styles from './Signaturecanvas.module.css';

const SignatureCanvas = ({ onSignatureChange, label = "Electronic Signature", required = false }) => {
    const sigPadRef = useRef(null);
    const [isEmpty, setIsEmpty] = useState(true);

    const handleEnd = () => {
        if (sigPadRef.current && !sigPadRef.current.isEmpty()) {
            const signatureData = sigPadRef.current.toDataURL('image/png');
            setIsEmpty(false);
            if (onSignatureChange) {
                onSignatureChange(signatureData);
            }
        }
    };

    const clearSignature = () => {
        if (sigPadRef.current) {
            sigPadRef.current.clear();
            setIsEmpty(true);

            if (onSignatureChange) {
                onSignatureChange(null);
            }
        }
    };

    return (
        <div className={styles.signatureContainer}>
            <div className={styles.headerRow}>
                <label className={styles.label}>
                    {label}
                    {required && <span className={styles.required}>*</span>}
                </label>
            </div>

            <div className={styles.signatureBox}>
                <p className={styles.signBelow}>Sign below {required && '*'}</p>

                <div className={styles.canvasWrapper}>
                    <SignaturePad
                        ref={sigPadRef}
                        canvasProps={{
                            className: styles.canvas
                        }}
                        onEnd={handleEnd}

                        penColor="black"
                    />
                </div>

                <div className={styles.buttonWrapper}>
                    <button
                        type="button"
                        onClick={clearSignature}
                        className={styles.clearButton}
                        disabled={isEmpty}
                    >
                        Clear Signature
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SignatureCanvas;